/**
 * Modifier class for tablet layouts. This is assigned to the Main tag,
 * and can be utilized via sub-classing.
 *
 * @example '${TABLET_LAYOUT} .my-class {}'
 */
export const TABLET_LAYOUT = ".layout--tablet";

/**
 * Modifier class for desktop layouts. This is assigned to the Main tag,
 * and can be utilized via sub-classing.
 *
 * @example '${DESKTOP_LAYOUT} .my-class {}'
 */
export const DESKTOP_LAYOUT = ".layout--desktop";

/**
 * The allotted max width for "readable" content.  This is optimize for ease
 * of reading and is not necessarily full bleed.
 */
export const MAX_READABLE_WIDTH = "52rem";